import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoaderSpinner from '../components/LoaderSpinner'

const BuyTravelPass = (props) => {
    const [loader, setLoader] = useState(true)

    
    useEffect(() => {
        document.getElementById('myTavelpass').submit();
    }, []);
    const getMarketByHref = () => {
        const href = window.location.href
        if (href.match(/.+\.sas\.se/)) {
            return "se-sv"
        } else if (href.match(/.+\.sas\.no/)) {
            return "no-no"
        } else if (href.match(/.+\.sas\.dk/)) {
            return "dk-da"
        } else if (href.match(/.+\.sas\.fi/)) {
            return "fi-en"
        } else if (href.match(/\/resmal\//)) {
            return "se-sv"
        } else if (href.match(/\/reisemal\//)) {
            return "no-no"
        } else if (href.match(/\/rejsemaal\//)) {
            return "dk-da"
        }
        return getMarketByPathname(href).toLowerCase()
    }

    const isDevEnvironment = () => {
        return (
            window.location.hostname === "localhost" ||
            window.location.hostname.match(/\.local/) ||
            window.location.hostname.match(/^10\..+/)
        )
    }
    const isTestEnvironment = () => {
        return !!window.location.hostname.match(/test\./)
    }
    const apiPath = () => {
        return isDevEnvironment() || isTestEnvironment()
            ? " https://travelpasstest.scandinavian.net/novaOnline/loginECommerce.do"
            : "https://travelpass.scandinavian.net/novaOnline/loginECommerce.do"
    }

    const getMarketByPathname = (href) => {
        return (href.match(/\/([a-z]{2}-[a-z]{2})(\/|$).*/i) || [])[1] || "se-sv"
    }
    return <>
     <LoaderSpinner loader={loader} />
    <form action={apiPath()} id="myTavelpass" method="post">
                <input type="hidden" name="CHN" value="ECOMM" />
                <input type="hidden" name="POS" value={getMarketByHref().split("-")[0].toUpperCase()} />
                <input type="hidden" name="LANG" value={getMarketByHref().split("-")[1].toUpperCase()} />
                <input type="hidden" name="RETURNURL" value="https://travelpass.scandinavian.net/web/menu/dist/webapp/#/" />
                <input type="hidden" name="TPACCOUNT" value="" />
                <input type="hidden" name="SSOTICKET" value="" />
                <input type="hidden" name="SIP_INTERNAL" value="70AD6463592C801C3391A2AF9484EA18AEB9759C04665CC516EA40E79A2DD5E3BA6BD7BEB1A5DBF250DB769F0C237A5879F97CE986BFD45AD828EE94111443CD79F97CE986BFD45AD828EE94111443CD79F97CE986BFD45AD828EE94111443CD79F97CE986BFD45AD828EE94111443CD79F97CE986BFD45AD828EE94111443CD" />
                <input type="submit" value="Submit" />
    </form>
</>
}
export default BuyTravelPass